import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import Loader from "Components/loader/Loader";
import { t } from "i18next";
import { Icon, notFound, arrowSort, arrowSortUp, arrowSortDown } from "Icons/index";

import cx from "classnames";
import s from "./responsiveTable.scss";
import qs from "query-string";

const ContextTypes = {
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
};

export default class ResponsiveTable extends React.Component {
  getOrderIcon(activeSorting) {
    if (activeSorting === "asc") {
      return <Icon className={s.iconSortActive} svg={arrowSortUp} width="0.5rem" height="0.5rem" />;
    }
    if (activeSorting === "desc") {
      return <Icon className={s.iconSortActive} svg={arrowSortDown} width="0.5rem" height="0.5rem" />;
    }
    return <Icon className={s.iconSort} svg={arrowSort} width="0.75rem" height="0.75rem" />;
  }

  sortByField(fieldName, sort) {
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: qs.stringify({
        ...qs.parse(this.props.location.search),
        page: 1,
        per: 25,
        sort_field: fieldName,
        sort: sort,
      }),
    });
  }

  orderIfOrderable(name, isOrderable, activeSorting) {
    if (isOrderable) {
      let sort = activeSorting;
      if (activeSorting === "asc") {
        sort = "desc";
      } else if (activeSorting === "desc") {
        sort = "none";
      } else {
        sort = "asc";
      }
      this.sortByField(name, sort);
    }
  }

  render() {
    const {
      className,
      verticalOnMobile,
      rows,
      areRowsLoading,
      headers,
      addIcon,
      addMsg,
      addDesc,
      iconPadding = false,
      showAddIcon = true,
      showAddMsg = true,
    } = this.props;
    let rowsToRender;

    const query = qs.parse(location.search);

    if (rows.length) {
      rowsToRender = rows;
    } else {
      rowsToRender = (
        <tr className={s.noFoundMsg}>
          <td colSpan={Object.keys(headers).length}>
            <div className={cx(s.wrapIllustration, { [s.iconPadding]: iconPadding })}>
              {showAddIcon && (
                <Icon
                  svg={query.query || query.status || query.customer_code || !addIcon ? notFound : addIcon}
                  width="10rem"
                  height="10rem"
                />
              )}
              {showAddMsg && (
                <div className={s.msgIllustration}>
                  {query.query || query.status || query.customer_code || !addMsg ? t("infoMsg.noRecords.msg") : addMsg}
                </div>
              )}

              <div className={s.descIllustration}>
                {query.query || query.status || query.customer_code || !addDesc ? t("infoMsg.noRecords.desc") : addDesc}
              </div>
            </div>
          </td>
        </tr>
      );
    }

    return (
      <table className={cx(className, s.responsiveTable, { [s.verticalOnMobile]: verticalOnMobile })}>
        <thead>
          <tr>
            {_.compact(
              _.map(headers, (header, i) => {
                if (header.sortable && !header.key) {
                  throw "Missing key attribute for sortable header";
                }

                if (header.hide) return undefined;
                return (
                  <th
                    key={i}
                    onClick={() => this.orderIfOrderable(header.key, header.sortable, header.activeSorting)}
                    colSpan={header.colSpan || 1}
                    className={cx({
                      [s.hideOnMobile]: header.hideOnMobile,
                      [s.justifyCenter]: header.center,
                      [s.justifyEnd]: header.right,
                      [s.sortable]: header.sortable,
                      [s.invisible]: header.invisible,
                    })}
                    style={{
                      width: `${header.size}`,
                    }}
                  >
                    {header.name}
                    {header.sortable && this.getOrderIcon(header.activeSorting, header.name)}
                  </th>
                );
              })
            )}
          </tr>
        </thead>
        <tbody>
          {areRowsLoading && (
            <tr className={s.loading}>
              <td colSpan={headers.length}>
                <div className={s.illustrationMsg}>
                  <Loader iconSize="3rem" msg={t("loading.msg.data")} />
                </div>
              </td>
            </tr>
          )}
          {!areRowsLoading && rowsToRender}
        </tbody>
      </table>
    );
  }
}

ResponsiveTable.contextTypes = ContextTypes;
